import React, { Fragment, useEffect, useState } from "react";
import { Dropdown, Menu, Icon, message, Spin, Modal, Tooltip } from "antd";
import { changeStatusOfOrders, updateReadyForCustomerCall } from "../../api/OrdersApi";
import { alertMessage } from "../../common/Common";
import BaseModal from "../BaseModal";
import I18n from "../../common/I18n";
import MoreChangeStatusForm from "./MoreChangeStatusForm";
import ChangeStatusForm from "../orders/ChangeStatusForm";
import OutboundDockTimeModal from "./OutboundDockTimeModal";
import { isLtlOrganization, ltlOrderStatusLabel, ltlAllLegsCompleted, shouldCaptureOutboundDockTime, ltlStatusChangeModalWidth } from "../../helpers/orders";
const OrderStatusDropdown = ({ orderResponse, currentOrg, getOrderDetails, organizationSettings, locked = false , exception_message, isDisabled = false, onCompletedStatusSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showReason, setShowReason] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [showOutboundDockModal, setShowOutboundDockModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [hasBulkOrders] = useState(false);
  const [matchedKey, setMatchedKey] = useState(true);
  const [selectedOrderStatus, setSelectedOrderStatus] = useState("");
  const [routes, setRoutes] = useState({
    selectedOrderKeys: [],
    selectedOrderRows: [],
  });

  const isImported = orderResponse?.customer_order_details?.is_imported === true || orderResponse?.customer_order_details?.is_imported === "true";
  const isCustomsCleared = orderResponse?.customer_order_details?.is_customs_cleared === true || orderResponse?.customer_order_details?.is_customs_cleared === "true";
  const isImportedButNotCleared = isImported && !isCustomsCleared;
  const readyForCustomer = !!orderResponse?.customer_order_details?.ready_for_customer || 
                           (orderResponse?.id && window.localStorage.getItem('ready_for_customer_' + orderResponse.id) === 'true');

  const isLtlOrg = isLtlOrganization(currentOrg);

  const [preDispatchStatus] = useState(
    isLtlOrg
      ? ["NEW", "RECEIVED", "ON_HAND", "PREPLAN"]
      : ["NEW", "RECEIVED", "VERIFIED", "PREPLAN"]
  );
  const [postDispatchStatus, setPostDispatchStatus] = useState(["PREPARE", "ASSIGNED", "DISPATCHED", "COMPLETED", "CLOSED"]);
  const { confirm } = Modal;
  //const [locked, setLocked] = useState(false); 


  // For an LTL org, On Hand is the relabel of Verified and is always available (no RECEIVED /
  // storage-transfer restriction). Non-LTL orgs keep Verified.
  const statusItems = [
    // { key: "PENDING", label: "Pending" },
    { key: "NEW", label: "New" },
    { key: "RECEIVED", label: "Received" },
    ...(isLtlOrg ? [{ key: "ON_HAND", label: "On Hand" }] : []),
    // ON_HOLD is not LTL-only - every org has it. LTL just relabels it to "Hold".
    { key: "ON_HOLD", label: isLtlOrg ? "Hold" : "On Hold" },
    ...(!isLtlOrg ? [{ key: "VERIFIED", label: "Verified" }] : []),
    // { key: "ASSIGNED", label: "Assigned" },
    // { key: "DISPATCHED", label: "Dispatched" },
    { key: "COMPLETED", label: "Completed" },
    { key: "EXCEPTION", label: "Exception" },
    { key: "CLOSED", label: "Closed" },
    // { key: "ARCHIVED", label: "Archived" },
  ];
  const baseStatusItems = statusItems.map((item) => ({
    ...item,
    onClick: () => showStatusChangeModal(),
  }));

//   useEffect(() => {
//     if (orderResponse?.customer_order_details?.is_locked !== undefined) {
//         setLocked(orderResponse.customer_order_details.is_locked === "true" ? true : false);
//     }
// }, [orderResponse]);
  
  const renderStatusChangeModal = () => {
    const orderObj = {
      ...orderResponse.customer_order_details,
      status: orderResponse.status || orderResponse.customer_order_details?.status,
      order_label: orderResponse.customer_order_details?.order_label || orderResponse.order_label,
      origin: {
        ...orderResponse.pickup_location_details,
      },
      destination:{
        ...orderResponse.delivery_location_details,
      }

    }
    return (
    <BaseModal
      title={`Change Status ${
        orderResponse && orderResponse.customer_order_number
          ? ` of #${orderResponse.customer_order_number}`
          : ""
      }`}
      onCancel={() => closeStatusChangeModal()}
      maskClosable={false}
      keyboard={false}
      width={ltlStatusChangeModalWidth({
        org: currentOrg,
        order: orderObj,
        isBulk: false,
        selectedStatus: selectedOrderStatus?.key,
        isNetmove: currentOrg?.code === I18n.t("account.netmove_code"),
      })}
      bodyStyle={{
        padding: 20,
      }}
    >
       {currentOrg?.code === I18n.t("account.netmove_code") ? (
        <MoreChangeStatusForm
        selectedOrderStatus={selectedOrderStatus}
        matchedkey={matchedKey?.toString() === "true"}
          currentStatus={orderObj?.status}
          saveStatus={() => callbackOfStatusChange()}
          orderObject={orderObj}
          closeModal={() => closeStatusChangeModal()}
          orders={[orderObj]}
          processErrors={() => processErrors()}
          hasBulkOrders={hasBulkOrders?.toString() === "true"}
          is_military_time={organizationSettings.is_military_time === "true"}
          showReason={showReason} 
          setShowReason={setShowReason}
          currentOrg={currentOrg}
          organizationSettings={organizationSettings}
        />
      ) : (
        <ChangeStatusForm
        organizationSettings={organizationSettings}
        selectedOrderStatus={selectedOrderStatus}
        matchedkey={matchedKey?.toString() === "true"}
        currentOrg={currentOrg}
        currentStatus={orderResponse?.status}
        saveStatus={() =>callbackOfStatusChange()}
        handleUpdateStatus={handleStatusChange}
        orderObject={orderResponse}
        closeModal={() => closeStatusChangeModal()}
        orders={[orderObj]}
        processErrors={() => processErrors()}
        hasBulkOrders={hasBulkOrders?.toString() === "true"}
        is_military_time={organizationSettings.is_military_time === "true"}
        showReason={showReason} 
        setShowReason={setShowReason}
        />
      )}
    </BaseModal>)
  };


  const handleChange = (item,hasRoute = false) => {
    const validStatuses = [ "CLOSED", "ARCHIVED"];

    if(!hasRoute){
      if (isLtlOrg) {
        validStatuses.push("NEW", "RECEIVED", "ON_HAND");
      } else {
        validStatuses.push("VERIFIED", "NEW", "RECEIVED");
      }
    }
    const orderForDockTime = {
      ...(orderResponse?.customer_order_details || {}),
      status: orderResponse?.status || orderResponse?.customer_order_details?.status,
      origin: orderResponse?.pickup_location_details,
      destination: orderResponse?.delivery_location_details,
    };
    const needsOutboundDockTime = shouldCaptureOutboundDockTime({
      org: currentOrg,
      order: orderForDockTime,
      isBulk: false,
      fromStatus: orderForDockTime.status,
      toStatus: item.key,
    });
    if (needsOutboundDockTime) {
      setSelectedOrderStatus(item);
      setShowOutboundDockModal(true);
      return;
    }
    // LTL: every leg already COMPLETED leaves the completion modal nothing to collect, so complete
    // the order directly with the existing status API.
    if (isLtlOrg && item.key === "COMPLETED" && ltlAllLegsCompleted(orderResponse)) {
      validStatuses.push("COMPLETED");
    }
    if (validStatuses.includes(item.key)) {
      setIsLoading(true);
        const selectedWarehouses =
        window.localStorage.getItem("selectedWarehouses");
        const data = {
        order_ids: orderResponse.id ? [orderResponse.id] : [],
        status: item.key,
        exception_code: "",
        exception_message: "",
        deletion_reason: "",
        warehouse_id: selectedWarehouses,
      };

      changeStatusOfOrders(data)
        .then((result) => {
          setIsLoading(false);
          if (result.success) {
            alertMessage(I18n.t("messages.processed"), 10);
            setIsLoading(false);
            setShowReason(false);
            callbackOfStatusChange(item.key);
          } else {
            setIsLoading(false);
            processErrors(result.errors);

            if (hasBulkOrders) {
              const errorOrders = result.errors
                ? result.errors.map((error) => error.order_number)
                : [];
              processErrors(errorOrders);
            }
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.error(error);
          message.error("An error occurred while updating the status.");
        });
    } else if (item.key === "COMPLETED" && isImported) {
      setIsLoading(true);
      const orgId = currentOrg?.id || orderResponse?.customer_order_details?.organization_id || orderResponse?.organization_id;
      updateReadyForCustomerCall(orderResponse.id, readyForCustomer, orgId, true)
        .then(() => {
          setIsLoading(false);
          setLoading(false);
          setRoutes({
            selectedOrderKeys: [],
            selectedOrderRows: [],
          });
          setIsModalVisible(false);
          getOrderDetails();
          if (onCompletedStatusSuccess) onCompletedStatusSuccess();
        })
        .catch((err) => {
          console.error("updateReadyForCustomerCall error:", err);
          setIsLoading(false);
          setLoading(false);
          setRoutes({
            selectedOrderKeys: [],
            selectedOrderRows: [],
          });
          setIsModalVisible(false);
          getOrderDetails();
        });
    } else {
      setSelectedOrderStatus(item);
      showStatusChangeModal();
    }
  }
  const handleMenuClick = (item) => {
    if (item.key === orderResponse.status) {
      message.error(`Cannot select current status: ${item.label}`);
    }
    else if(postDispatchStatus.includes(orderResponse.status) &&
    preDispatchStatus.includes(item.key)){
      confirm({
        title: I18n.t("messages.order_deleted_from_route"),
        content: <span className="">{I18n.t("messages.proceed_confirm")}</span>,
        onOk: () => {
            if(!['EXCEPTION','ON_HOLD'].includes(item.key)){
              setShowReason(true); 
            }
            showStatusChangeModal()
            handleChange(item,true)
        },
        okText: "Yes",
        okType: "danger",
        cancelText: "No",
        onCancel: () => {},
      });
    } 
    else {
     handleChange(item)
    }
  };

  const callbackOfStatusChange = (statusKey = selectedOrderStatus?.key) => {
    if (statusKey === "COMPLETED" && onCompletedStatusSuccess) {
      onCompletedStatusSuccess();
    }
    if (statusKey === "COMPLETED" && isImported) {
      const orgId = currentOrg?.id || orderResponse?.customer_order_details?.organization_id || orderResponse?.organization_id;
      updateReadyForCustomerCall(orderResponse.id, readyForCustomer, orgId, true)
        .then(() => {
          setLoading(false);
          setRoutes({
            selectedOrderKeys: [],
            selectedOrderRows: [],
          });
          setIsModalVisible(false);
          setShowOutboundDockModal(false);
          getOrderDetails();
        })
        .catch((err) => {
          console.error("updateReadyForCustomerCall error:", err);
          setLoading(false);
          setRoutes({
            selectedOrderKeys: [],
            selectedOrderRows: [],
          });
          setIsModalVisible(false);
          setShowOutboundDockModal(false);
          getOrderDetails();
        });
    } else {
      setLoading(false);
      setRoutes({
        selectedOrderKeys: [],
        selectedOrderRows: [],
      });
      setIsModalVisible(false);
      setShowOutboundDockModal(false);
      getOrderDetails();
    }
  };

  const processErrors = (errors) => {
    const updatedRoutes = {
      selectedOrderKeys: [],
      selectedOrderRows: [],
    };

    if (errors?.length > 0) {
      errors.forEach((order) => {
        const errorOrder = _.find(orderResponse.customer_order_details
              ? [orderResponse.customer_order_details]
              : [], {
          customer_order_number: order,
        });
        if (!_.isEmpty(errorOrder)) {
          updatedRoutes.selectedOrderKeys.push(errorOrder.id);
          updatedRoutes.selectedOrderRows.push(errorOrder);
        }
      });
    }

    setRoutes(updatedRoutes);
    getOrderDetails();
  };



  const menu = (
    <Menu className="menu-items">
      {baseStatusItems.map((item) => (
        <Menu.Item
          data-testid={`status-${item.label}`}
          key={item.key}
          onClick={() => handleMenuClick(item)}
          disabled={
            item.key === orderResponse.status || 
            (orderResponse?.customer_order_details?.approval_details && orderResponse.customer_order_details.approval_details.length > 0) ||
            (item.key === "COMPLETED" && isImportedButNotCleared)
          }
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          {item.label}
          {
            item.key === orderResponse.status && (
              <Icon type="check" style={{ fontSize: 16, marginLeft: 10 ,marginTop: '2px'}} />
            )
          }
        </Menu.Item>
      ))}
    </Menu>
  );

  const showStatusChangeModal = (order, status) => {
    setIsModalVisible(true);
  };

  const closeStatusChangeModal = () => {
    setIsModalVisible(false);
    setShowOutboundDockModal(false);
  };

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
  };

  return (
<Fragment>
  <Tooltip title={locked ? "Status change is locked" : (orderResponse.status === "EXCEPTION" ? exception_message || "Not available" : "")}>
    <Dropdown overlay={menu} trigger={["click"]} disabled={locked || isDisabled}>
      <Spin spinning={isLoading}>
        <div
          data-testid="status-dropdown"
          className="chip"
          onClick={(e) => e.preventDefault()}
          style={{
            background: orderResponse.status === "EXCEPTION" ? "#ff2d78" : "#576EC1", 
            display: "flex",
            alignItems: "center",
            gap: 4,
          }}
        >
          {ltlOrderStatusLabel(orderResponse.status, isLtlOrg)}{" "}
          {!locked && !isDisabled && <Icon style={{ fontSize: 12 }} type="caret-down" />}
          {orderResponse.status === "EXCEPTION" && (
            <Icon type="info-circle" style={{ fontSize: 14, color: "#fff" }} />
          )}
        </div>
      </Spin>
    </Dropdown>
  </Tooltip>
  {isModalVisible && renderStatusChangeModal()}
  <OutboundDockTimeModal
    visible={showOutboundDockModal}
    orderId={orderResponse?.id || orderResponse?.customer_order_details?.id}
    orderNumber={orderResponse?.customer_order_number}
    order={{
      ...(orderResponse?.customer_order_details || {}),
      status: orderResponse?.status || orderResponse?.customer_order_details?.status,
      origin: orderResponse?.pickup_location_details,
      destination: orderResponse?.delivery_location_details,
      delivery_location_details: orderResponse?.delivery_location_details,
      locations: orderResponse?.locations,
    }}
    isMilitaryTime={organizationSettings?.is_military_time === "true" || organizationSettings?.is_military_time === true}
    onCancel={closeStatusChangeModal}
    onSuccess={callbackOfStatusChange}
  />
</Fragment>

  );
};

export default OrderStatusDropdown;
